import api from '@/api/index.js'

const emv_success_payments_summary_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    LoadEmvSuccessPaymentsSummaryReport({commit}, query) {
      let reqQueryStr = '';
      if (query.ignoreCache === true) {
        reqQueryStr += 'ignore-cache=t&'
      }

      if (query.period.year) {
        reqQueryStr += `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr += `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT_ERROR', null)
      commit('SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT', null)
      commit('SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT_LOADING', true)
      return api.get('reports/emv-success-payments-summary?' + reqQueryStr)
        .then((response) => {
          commit('SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT', response)
        })
        .catch((error) => {
          commit('SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_SUCCESS_PAYMENTS_SUMMARY_REPORT_LOADING', false)
        })
    }
  },
}

export default emv_success_payments_summary_report
